import classNames from "classnames";
import { resolveFormattedTextString, setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { Button } from "../Button/Button";
import { Icon, FontIconName } from "../Icon/Icon";
import styles from "./NoResults.module.less";
import { FormattedTextString } from "client/Misc/commonTypes";

export type NoResultsProps = {
	icon: FontIconName;
	title: string;
	message: string | FormattedTextString;
	onRetry?(): void;
	height?: "auto" | "fill";
	hasExtraTopPadding?: boolean;
	trackingId?: string;
} & (
	{
		onRetry?: undefined;
	}
	|
	{
		onRetry: () => void;
		retryText?: string | FormattedTextString;
	}
);

export const NoResults = (props: NoResultsProps): ReactElement => {
	const {
		icon,
		title,
		message,
		height = "auto",
		hasExtraTopPadding = false,
	} = props;

	return (
		<div
			{...setTrackingId(props.trackingId)}
			className={
				classNames(
					styles.container,
					{
						[styles.container_fillHeight]: height === "fill",
						[styles.container_extraTopPadding]: hasExtraTopPadding
					}
				)
			}
		>
			<div className={styles.root}>
				<div className={styles.icon}>
					<div className={styles.icon_backBox} />
					<div className={styles.icon_inner}>
						<div className={styles.icon_container}>
							<Icon
								value={{
									kind: "font",
									name: icon,
									color: "primary"
								}}
							/>
						</div>
					</div>
				</div>
				<h4
					{...setTrackingId("title")}
					className={styles.title}>{title}
				</h4>
				<p
					{...setTrackingId("message")}
					className={styles.message}
				>
					{resolveFormattedTextString(message)}
				</p>
				{props.onRetry && (
					<div className={styles.button}>
						<Button
							trackingId="retry"
							text={props.retryText ?? localize("_Retry")}
							kind="primary"
							onClick={props.onRetry}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

NoResults.displayName = "NoResults";